import { renderToStaticMarkup } from "react-dom/server";

export const loadImg = (src, cors) => new Promise((resolve) => {
  if (!src) return resolve(null);
  const img = new Image();
  if (cors) img.crossOrigin = "anonymous";
  img.onload = () => resolve(img);
  img.onerror = () => resolve(null);
  img.src = src;
});

export const iconImg = (Icon, color) => {
  const svg = renderToStaticMarkup(<Icon color={color} size={256} strokeWidth={2} xmlns="http://www.w3.org/2000/svg" />);
  return loadImg(`data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`);
};

export const roundRect = (ctx, x, y, w, h, r) => { ctx.beginPath(); ctx.roundRect(x, y, w, h, r); };

export const text = (ctx, str, x, y, { size, weight = 700, color = "#fff", font = "Outfit", align = "center", maxW, fit }) => {
  ctx.font = `${weight} ${size}px "${font}", sans-serif`;
  while (fit && maxW && size > 18 && ctx.measureText(str).width > maxW) { size -= 2; ctx.font = `${weight} ${size}px "${font}", sans-serif`; }
  ctx.fillStyle = color;
  ctx.textAlign = align;
  let s = str;
  while (maxW && ctx.measureText(s).width > maxW && s.length > 4) s = s.slice(0, -2);
  ctx.fillText(s === str ? s : `${s.trim()}…`, x, y);
};

export const drawHeart = (ctx, x, y, size, color, rot = 0) => {
  ctx.save(); ctx.translate(x, y); ctx.rotate(rot); ctx.scale(size / 100, size / 100);
  ctx.beginPath(); ctx.moveTo(0, 30);
  ctx.bezierCurveTo(0, 0, -50, 0, -50, 30); ctx.bezierCurveTo(-50, 60, -10, 80, 0, 100);
  ctx.bezierCurveTo(10, 80, 50, 60, 50, 30); ctx.bezierCurveTo(50, 0, 0, 0, 0, 30);
  ctx.fillStyle = color; ctx.fill(); ctx.restore();
};

const sparkle = (ctx, x, y, r, alpha) => {
  ctx.save(); ctx.translate(x, y); ctx.fillStyle = `rgba(255,255,255,${alpha})`; ctx.beginPath();
  for (let i = 0; i < 8; i++) { const rr = i % 2 ? r * 0.28 : r; const a = (i * Math.PI) / 4; ctx.lineTo(Math.cos(a) * rr, Math.sin(a) * rr); }
  ctx.closePath(); ctx.fill(); ctx.restore();
};

const glow = (ctx, x, y, r, color) => {
  const g = ctx.createRadialGradient(x, y, 0, x, y, r);
  g.addColorStop(0, color); g.addColorStop(1, "rgba(255,255,255,0)");
  ctx.fillStyle = g; ctx.fillRect(x - r, y - r, r * 2, r * 2);
};

export const drawGrain = (ctx, W, H, n = 9000) => {
  for (let i = 0; i < n; i++) { ctx.fillStyle = `rgba(255,255,255,${Math.random() * 0.07})`; ctx.fillRect(Math.random() * W, Math.random() * H, 2, 2); }
};

export const drawBackground = (ctx, W, H) => {
  const g = ctx.createLinearGradient(0, 0, W * 0.6, H);
  g.addColorStop(0, "#FF9A8B"); g.addColorStop(0.35, "#FF5E9C"); g.addColorStop(0.7, "#EC4899"); g.addColorStop(1, "#C026D3");
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
  glow(ctx, W * 0.12, H * 0.08, W * 0.7, "rgba(255,255,255,0.38)");
  glow(ctx, W * 0.98, H * 0.55, W * 0.6, "rgba(253,186,116,0.35)");
  glow(ctx, W * 0.2, H * 0.98, W * 0.6, "rgba(168,85,247,0.35)");
  [[0.88, 0.1, 120, 0.18, 0.3], [0.08, 0.42, 80, 0.14, -0.4], [0.92, 0.74, 95, 0.16, 0.25], [0.15, 0.88, 60, 0.2, -0.2], [0.55, 0.03, 50, 0.16, 0.5]].forEach(([x, y, sz, a, r]) => drawHeart(ctx, W * x, H * y, sz * (W / 1080), `rgba(255,255,255,${a})`, r));
  [[0.2, 0.18, 22, 0.8], [0.8, 0.3, 16, 0.7], [0.1, 0.65, 14, 0.6], [0.86, 0.9, 20, 0.7], [0.65, 0.12, 12, 0.6]].forEach(([x, y, r, a]) => sparkle(ctx, W * x, H * y, r * (W / 1080), a));
  drawGrain(ctx, W, H);
};

export const drawBrand = async (ctx, W, cy, scale = 1) => {
  const logo = await loadImg("/logo-mark.png");
  const ls = 64 * scale, gap = 18 * scale;
  ctx.font = `800 ${52 * scale}px "Outfit", sans-serif`;
  const tw = ctx.measureText("itzPlay").width;
  ctx.font = `700 ${18 * scale}px "Plus Jakarta Sans", sans-serif`;
  const sw = ctx.measureText("C O M M U N I T Y").width;
  const w = ls + gap + Math.max(tw, sw) + 56 * scale, h = ls + 28 * scale, x = W / 2 - w / 2, y = cy - h / 2;
  roundRect(ctx, x, y, w, h, h / 2); ctx.fillStyle = "rgba(255,255,255,0.2)"; ctx.fill();
  ctx.lineWidth = 2; ctx.strokeStyle = "rgba(255,255,255,0.45)"; ctx.stroke();
  const lx = x + 18 * scale;
  if (logo) { ctx.save(); roundRect(ctx, lx, cy - ls / 2, ls, ls, ls * 0.3); ctx.clip(); ctx.drawImage(logo, lx, cy - ls / 2, ls, ls); ctx.restore(); }
  text(ctx, "itzPlay", lx + ls + gap, cy + 6 * scale, { size: 52 * scale, weight: 800, align: "left" });
  text(ctx, "C O M M U N I T Y", lx + ls + gap + 2, cy + 30 * scale, { size: 18 * scale, weight: 700, font: "Plus Jakarta Sans", align: "left", color: "rgba(255,255,255,0.85)" });
};

export const codeFrom = (link) => { try { return new URL(link).searchParams.get("ref") || ""; } catch { return ""; } };

export const drawCta = async (ctx, W, y, h, { code, title = "Kostenlos mitmachen & Punkte für Geschenke sammeln" }) => {
  const x = 64, w = W - 128, big = h >= 220;
  ctx.save(); ctx.shadowColor = "rgba(131,24,67,0.35)"; ctx.shadowBlur = 50; ctx.shadowOffsetY = 18;
  roundRect(ctx, x, y, w, h, 44); ctx.fillStyle = "#fff"; ctx.fill(); ctx.restore();
  const logo = await loadImg("/logo-mark.png");
  const ls = Math.min(h - 56, big ? 150 : 104), lx = x + 28;
  if (logo) { ctx.save(); roundRect(ctx, lx, y + (h - ls) / 2, ls, ls, ls * 0.28); ctx.clip(); ctx.drawImage(logo, lx, y + (h - ls) / 2, ls, ls); ctx.restore(); }
  const cx = lx + ls + 28, cw = x + w - 32 - cx;
  text(ctx, title, cx, y + h * (big ? 0.38 : 0.4), { size: big ? 40 : 30, weight: 800, color: "#1E1B1D", align: "left", maxW: cw, fit: true });
  const host = new URL(process.env.REACT_APP_SITE_URL || window.location.origin).host.replace(/^www\./, "");
  const ph = big ? 64 : 48, py = y + h * (big ? 0.55 : 0.54);
  ctx.font = `800 ${big ? 30 : 24}px "Outfit", sans-serif`;
  const hw = Math.min(ctx.measureText(`${host}  →`).width + 40, cw - (code ? 190 : 0));
  const g = ctx.createLinearGradient(cx, 0, cx + hw, 0); g.addColorStop(0, "#F43F5E"); g.addColorStop(1, "#D946EF");
  roundRect(ctx, cx, py, hw, ph, ph / 2); ctx.fillStyle = g; ctx.fill();
  text(ctx, `${host}  →`, cx + hw / 2, py + ph * 0.66, { size: big ? 30 : 24, weight: 800, maxW: hw - 30, fit: true });
  if (code) {
    const kx = cx + hw + 14, kw = Math.min(cw - hw - 14, big ? 230 : 180);
    roundRect(ctx, kx, py, kw, ph, ph / 2); ctx.fillStyle = "#FEF3C7"; ctx.fill();
    text(ctx, `Code ${code}`, kx + kw / 2, py + ph * 0.66, { size: big ? 28 : 22, weight: 800, color: "#B45309", maxW: kw - 24, fit: true });
  }
};

export const drawAvatar = (ctx, img, name, cx, cy, r) => {
  ctx.save();
  ctx.beginPath(); ctx.arc(cx, cy, r + 6, 0, Math.PI * 2); ctx.fillStyle = "#fff"; ctx.fill();
  ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2); ctx.clip();
  if (img) ctx.drawImage(img, cx - r, cy - r, r * 2, r * 2);
  else { ctx.fillStyle = "#FDE2E8"; ctx.fillRect(cx - r, cy - r, r * 2, r * 2); text(ctx, (name || "?")[0].toUpperCase(), cx, cy + r * 0.35, { size: r, color: "#E11D48" }); }
  ctx.restore();
};

const LAYOUTS = {
  story: { W: 1080, H: 1920, logoY: 150, badgeY: 640, badgeR: 230, labelY: 990, titleY: 1090, descY: 1160, avatarY: 1330, nameY: 1460, cardY: 1560, cardH: 250 },
  square: { W: 1080, H: 1080, logoY: 90, badgeY: 360, badgeR: 150, labelY: 580, titleY: 650, descY: 705, avatarY: 790, nameY: 790, cardY: 880, cardH: 160 },
};

export async function renderBadgeImage({ badge, Icon, user, link, format, label = "NEUES ABZEICHEN FREIGESCHALTET", ring: ringColors = ["#FBBF24", "#EC4899"], iconColor = "#E11D48" }) {
  const L = LAYOUTS[format];
  const { W, H } = L;
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  await document.fonts?.ready;
  const [icon, avatar] = await Promise.all([iconImg(Icon, iconColor), loadImg(user.picture, true)]);
  drawBackground(ctx, W, H);
  await drawBrand(ctx, W, L.logoY, format === "story" ? 1.2 : 1);

  [1.55, 1.3].forEach((m, i) => { ctx.beginPath(); ctx.arc(W / 2, L.badgeY, L.badgeR * m, 0, Math.PI * 2); ctx.fillStyle = `rgba(255,255,255,${i ? 0.18 : 0.1})`; ctx.fill(); });
  ctx.save(); ctx.shadowColor = "rgba(131,24,67,0.4)"; ctx.shadowBlur = 60; ctx.shadowOffsetY = 20;
  ctx.beginPath(); ctx.arc(W / 2, L.badgeY, L.badgeR, 0, Math.PI * 2); ctx.fillStyle = "#fff"; ctx.fill(); ctx.restore();
  const ring = ctx.createLinearGradient(W / 2 - L.badgeR, 0, W / 2 + L.badgeR, 0); ring.addColorStop(0, ringColors[0]); ring.addColorStop(1, ringColors[1]);
  ctx.lineWidth = 14; ctx.strokeStyle = ring; ctx.beginPath(); ctx.arc(W / 2, L.badgeY, L.badgeR - 7, 0, Math.PI * 2); ctx.stroke();
  const is = L.badgeR * 1.0;
  if (icon) ctx.drawImage(icon, W / 2 - is / 2, L.badgeY - is / 2, is, is);

  const lw = format === "story" ? 640 : 560, lh = format === "story" ? 64 : 54;
  roundRect(ctx, W / 2 - lw / 2, L.labelY - lh * 0.7, lw, lh, lh / 2); ctx.fillStyle = "rgba(255,255,255,0.22)"; ctx.fill();
  text(ctx, label, W / 2, L.labelY, { size: format === "story" ? 30 : 26, weight: 800, font: "Plus Jakarta Sans", maxW: lw - 40 });
  text(ctx, badge.title, W / 2, L.titleY, { size: format === "story" ? 112 : 84, weight: 800, maxW: W - 120, fit: true });
  text(ctx, badge.description, W / 2, L.descY, { size: 40, weight: 500, font: "Plus Jakarta Sans", maxW: W - 160, color: "rgba(255,255,255,0.92)" });

  if (format === "story") {
    drawAvatar(ctx, avatar, user.name, W / 2, L.avatarY, 70);
    text(ctx, user.name, W / 2, L.nameY, { size: 52, weight: 700, maxW: W - 200 });
  } else {
    ctx.font = `700 44px "Outfit", sans-serif`;
    const nw = Math.min(ctx.measureText(user.name).width, 600);
    const x0 = W / 2 - (nw + 100) / 2;
    drawAvatar(ctx, avatar, user.name, x0 + 36, L.avatarY - 14, 36);
    text(ctx, user.name, x0 + 92, L.nameY, { size: 44, align: "left", maxW: 600 });
  }
  await drawCta(ctx, W, L.cardY, L.cardH, { code: codeFrom(link) });
  return new Promise((resolve) => c.toBlob((b) => resolve(b), "image/png"));
}
